<template>
    <el-row :gutter="4" class="h100">
        <div class="el-table-container">
            <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                     @keyup.enter.native="refreshList(1,1,1)" @submit.native.prevent label-width="120px">
                <el-form-item label="输入搜索：" prop="keyWord">
                    <el-input v-model.trim="searchForm.keyWord" maxlength="50" placeholder="请输入关键字(限50字)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="收藏时间：" prop="collectionTime">
                    <el-date-picker
                            v-model="searchForm.collectionTime"
                            clearable
                            style="width: 100%"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                    </el-button>
                    <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                </el-form-item>
                <el-form-item class="f_r">
                    <el-button v-if="hasPermission('sys:personal:myCollection:cancelCollection')" type="primary"
                               @click="cancelCollection()" size="small">取消收藏
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @sort-change="sortChange"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="createDate" sortable='custom' label="收藏时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="resourceName" label="资源名称" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <div class="flex_l_c">
                            <el-tag size="small" v-show="row.delFlag == 1" style="margin-right: 10px">已删除</el-tag>
                            <div>{{ row.resourceName }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="资源状态" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" min-width="100px" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('sys:personal:myCollection:detail')" type="text" size="small"
                                   @click="detail(row)">详情
                        </el-button>
                        <el-button v-if="hasPermission('sys:personal:myCollection:cancelCollection')" type="text"
                                   size="small" @click="cancelCollection(row)">取消收藏
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                        @pagination="refreshList"/>
        </div>
        <resource-add-edit-form ref="resourceAddEditForm"></resource-add-edit-form>
    </el-row>
</template>

<script>

import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "myCollection",
    components: {ResourceAddEditForm},
    data() {
        return {
            searchForm: {
                basicDataId: '',
                keyWord: '',
                collectionTime: [],
                beginData: '',
                endData: '',
                current: 1,
                size: 20,
            },
            total: 0,
            sort: '',
            loading: false,
            tabHeadList: [],
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
       this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            if (this.searchForm.collectionTime && this.searchForm.collectionTime.length == 2) {
                this.searchForm.startTime = this.searchForm.collectionTime[0]
                this.searchForm.endTime = this.searchForm.collectionTime[1]
            } else {
                this.searchForm.startTime = ''
                this.searchForm.endTime = ''
            }
            this.loading = true
            this.$axios(this.api.metadata.academicMyCollectionList, {
                ...this.searchForm,
                sort: this.sort,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.$nextTick(() => {
                        this.$refs.multipleTable.doLayout()
                    })
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        // 列表排序
        sortChange(column) {
            if (column.order) {
                this.sort = 'create_date '
                this.sort += column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
                this.refreshList()
            } else {
                this.sort = ''
                this.refreshList(1, 1, 1)
            }
        },

        //详情
        detail(row) {
            if (row.delFlag == '1') {
                this.$message.warning('该数据已删除！')
                return
            }
            this.$refs.resourceAddEditForm.init('view', row.metadataId, '', row.basicDataId,'',row)
        },

        //取消收藏
        cancelCollection(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.metadataId
            })
            this.$confirm(`您是否确认取消收藏所选数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.metadata.academicMyCollectionUpdateByIds, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('取消收藏成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
}
</script>

<style scoped>
.metadataTree {
    background: #ffffff;
}

.el-menu {
    border-right: none !important;
}

.el-menu-item, .el-submenu__title {
    height: 34px !important;
    line-height: 34px !important;
    font-size: 14px;
}
</style>
